import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {LocationHeaderContainerModel} from '../../../../../../models/aggregates/erp/location';


@Injectable({
  providedIn: 'root'
})
export class LocationHdrService extends BaseApiTemplateService<LocationHeaderContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'pg/bl_inv_mst_location';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'pg/bl_inv_mst_location';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'pg/bl_inv_mst_location';
    this.httpClient = http;
  }

}
